import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const iconWrapper: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  padding: (p) => p.spacing(0.25),
  borderRadius: (p) => p.spacing(0.5),
};

export const icon: SxStyle = {
  color: (p) => p.palette.common.black,
};

export const disabledIcon: SxStyle = {
  color: (p) => p.palette.grey[400],
};
